export const config = {
  title: "BlueRidge Custom Sweeping LLC | Professional Cleaning Services | Winchester, OH",
  meta: {
    description:
      "BlueRidge Custom Sweeping LLC provides professional mobile cleaning services in Winchester, OH. Street sweeping, construction cleaning, power washing, and property maintenance with 5+ years experience and BBB accreditation.",
    keywords: [
      "BlueRidge Custom Sweeping",
      "Street Sweeping Winchester OH",
      "Construction Cleaning Ohio",
      "Power Washing Services",
      "Industrial Sweeping",
      "Parking Lot Cleaning",
      "Property Maintenance Ohio",
      "Commercial Cleaning Winchester"
    ],
    author: "BlueRidge Custom Sweeping LLC",
    canonicalUrl: "https://blueridgecustomsweeping.com/",
  },
  sections: {
    header: {
      businessName: "BlueRidge Custom Sweeping LLC",
    },
    sectionB: {
      heroTitle: "Professional Mobile Cleaning Solutions",
      heroSubtitle: "Street Sweeping, Construction Cleanup & Power Washing | Winchester, OH",
      learnAboutText: "Get Your Free Estimate",
      phoneNumber: "5135823784",
      phoneLabel: "(513) 582-3784",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/98178453/photo/sweeper.jpg?s=612x612&w=0&k=20&c=0qLxQ-zO2EWREqV-wxj-AN0MSw4QGQDrqv4QaDAQdPU=",
      cardData: [
        {
          title: "Street Sweeping",
          description:
            "Professional street sweeping services for municipalities, commercial properties, and parking lots with modern equipment.",
        },
        {
          title: "Construction Cleanup",
          description:
            "Comprehensive construction site cleaning and debris removal services to keep your projects on schedule and compliant.",
        },
        {
          title: "Power Washing",
          description:
            "High-pressure cleaning services for buildings, sidewalks, parking lots, and various surfaces to restore appearance.",
        },
      ],
      description:
        "BlueRidge Custom Sweeping LLC delivers exceptional mobile cleaning services tailored for commercial sites, residential areas, and public spaces in Winchester, OH. With 5+ years of experience and BBB accreditation, we provide certified, insured services you can trust.",
    },
    sectionC: {
      servicesTitle: "Comprehensive Cleaning Solutions",
      servicesDescription:
        "Professional mobile cleaning services designed to eliminate dirt, debris, and downtime from your property. Our team delivers thorough cleaning solutions with modern equipment and reliable scheduling that fits your needs.",
      cards: [
        {
          title: "Street & Parking Lot Sweeping",
          description:
            "Professional sweeping services for streets, parking lots, highways, and industrial sites using modern equipment and efficient techniques.",
          imageSrc: "https://media.istockphoto.com/id/2017532990/photo/tractor-brush-for-cleaning-roads-close-up.jpg?s=612x612&w=0&k=20&c=H1JW7xgj0UlnZDNc4oDgaJ0IjOVzVe6pCtF49w8ebRM=",
          imageAlt: "Street Sweeping Services",
        },
        {
          title: "Construction & Industrial Cleaning",
          description:
            "Specialized cleaning for construction sites, industrial facilities, and commercial properties including debris removal and site preparation.",
          imageSrc: "https://media.istockphoto.com/id/1300553713/photo/construction-garbage.jpg?s=612x612&w=0&k=20&c=xyXa5Hu2B2mtN9nTLmTTvcUgAZPgdalNYDVtgoZnAyU=",
          imageAlt: "Construction Cleaning Services",
        },
        {
          title: "Power Washing & Maintenance",
          description:
            "High-pressure cleaning services for buildings, sidewalks, and surfaces plus ongoing property maintenance and stain removal.",
          imageSrc: "https://media.istockphoto.com/id/532868723/photo/power-washing.jpg?s=612x612&w=0&k=20&c=1d7uQLQ7plhid2Jt2ETvOTKfDauX9cQOzzdJgfDXCt8=",
          imageAlt: "Power Washing Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Dust Control & Air Quality Management",
        "Catch Basin & Storm Drain Cleaning",
        "Airport Runway Sweeping",
        "Emergency Cleanup Services",
        "Special Event Site Preparation",
      ],
    },
    sectionD: {
      aboutTitle: "About BlueRidge Custom Sweeping LLC",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1094152694/photo/men-washing-driveway.jpg?s=612x612&w=0&k=20&c=hTC_sSo0iwSaDaVd_KOGdKmt7KxtbDJDuUoyPsOmF8U=",
        alt: "BlueRidge Custom Sweeping Professional Team",
      },
      aboutText: [
        "BlueRidge Custom Sweeping LLC is a trusted provider of professional mobile cleaning services based in Winchester, OH. With over 5 years of hands-on experience and roots going back to 1994, we offer certified, insured services backed by BBB accreditation and longstanding community trust.",
        "Our mobile-only model allows us to respond quickly with thorough service across multiple environments within a 30-mile radius. We focus on keeping facilities clean without disrupting operations, offering 30-day billing options and consistent scheduling that fits your needs. From street sweeping to construction cleanup, we treat every location with the same care and attention to detail.",
      ],
    },
    sectionE: {
      profileImage: null, // URL or null
      profileAlt: "BlueRidge Custom Sweeping LLC Professional Services",
      businessName: "BlueRidge Custom Sweeping LLC",
      contact: {
        phone: "5135823784",
        phoneLabel: "(513) 582-3784",
        email: "Darryl.whalen.dw@gmail.com",
        website: "https://blueridgecustomsweeping.com/",
        address: "Winchester, OH 45697",
      },
      socialMedia: {
        bizSolutionsUrl: "https://mybizsolutions.us/biz/blueridge-custom-sweeping-llc",
        googlePlus: "",
        linkedIn: "",
        facebook: "",
        twitter: "",
        tiktok: "",
        instagram: "",
        youtube: "",
        // "" if empty. 
      },
    },
    sectionF: {
      address: "Winchester, OH 45697",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d98234.12345678!2d-83.6543210!3d38.9876543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x884234567890abcd%3A0x1234567890abcdef!2sWinchester%2C%20OH%2045697!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;